import { useEffect, useState } from "react";
import { getMythIcons } from "./dreamCar-service";
import DOMPurify from "dompurify";

const MythIcons = () => {
  const [mythIconsContent, setMyIconsContent] = useState("");
  useEffect(() => {
    (async () => {
      let areMythIconsAdded = false;
      try {
        const res = await getMythIcons();
        setMyIconsContent(await res.json());
        areMythIconsAdded = true;
      } catch (err) {
        areMythIconsAdded = false;
        console.error("Error while fetching the Myth Icons");
      } finally {
        setTimeout(
          () =>
            dispatchEvent(
              new CustomEvent("mythIconsApiEvent", {
                detail: {
                  areMythIconsAdded,
                },
              })
            ),
          500
        );
      }
    })();
  }, []);

  return <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(mythIconsContent) }} />;
};

export default MythIcons;
